import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/game/$")({
  beforeLoad: ({ params }) => {
    throw redirect({ statusCode: 301, to: `/attraction/${params._splat}` });
  },
});
